<script>
export const group = 'Full'
</script>

<script setup>
import TextSlideUp from './text_animations/TextSlideUp.vue'
import CharacterJumpFromTheRight from './text_animations/CharacterJumpFromTheRight.vue'
import { frames } from '../../../utils/frames'
import ToFullTopLeft from './transitions/energetic_frequencies/ToFullTopLeft.vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const scoreA = computed(() => item.enrichment?.players.find((player) => player.name === 'mattie')?.score)
const scoreB = computed(() => item.enrichment?.players.find((player) => player.name === 'marieke')?.score)

const timelineVlaggenLeft = ref(null)
const timelineVlaggenRight = ref(null)
const timelineNameLeft = ref(null)
const timelineNameRight = ref(null)

const versusTextElement = ref(null)
const scoreTextElement = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'MattieVsMariekeScore', delay: frames(15) })
    .add(timelineNameLeft)
    .from(versusTextElement, { scale: 0, duration: frames(14), transformOrigin: 'bottom center', ease: 'back.out(1.7)' }, `<${frames(20)}`)
    .add(timelineNameRight, `<${frames(8)}`)
    .to(versusTextElement, { opacity: 0, yPercent: 400, duration: frames(8), transformOrigin: 'top center', ease: 'power1.inOut' }, `<${frames(20)}`)
    .from(scoreTextElement, { scale: 0, duration: frames(14), transformOrigin: 'bottom center', ease: 'back.out(1.7)' }, `<${frames(9)}`)
    .add(timelineVlaggenLeft, `=+${frames(2)}`)
    .add(timelineVlaggenRight, `<`)
})
</script>

<template>
  <ToFullTopLeft>
    <div class="size-full relative font-cervo text-white">
      <img src="../../../assets/images/mattie_vs_marieke_background.jpg" class="size-full object-cover" />
      <div class="absolute inset-0 flex items-end justify-center pb-[80px]">
        <div class="flex items-end gap-6">
          <div class="flex flex-col items-end w-112 pb-9">
            <TextSlideUp :text="`${scoreA} / 10 Vlaggen`" class="text-[50px]" @timeline="timelineVlaggenLeft = $event" />
            <CharacterJumpFromTheRight text="Mattie" class="-mt-2 mb-1" textSizeClass="text-[160px]" textOutlineSizeClass="text-[220px]" @timeline="timelineNameLeft = $event" />
          </div>
          <div class="text-[360px] font-bold leading-none px-8 text-center relative">
            <div ref="versusTextElement" class="absolute w-[34rem]">vs</div>
            <div ref="scoreTextElement" class="abolute w-[34rem]">{{ scoreA }}<span class="px-4">-</span>{{ scoreB }}</div>
          </div>
          <div class="flex flex-col items-start w-112 pb-9">
            <TextSlideUp :text="`${scoreB} / 10 Vlaggen`" class="text-[50px]" @timeline="timelineVlaggenRight = $event" />
            <CharacterJumpFromTheRight text="Marieke" class="-mt-2 mb-1" textSizeClass="text-[160px]" textOutlineSizeClass="text-[220px]" @timeline="timelineNameRight = $event" />
          </div>
        </div>
      </div>
    </div>
  </ToFullTopLeft>
</template>
